var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordRoundedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 89,
    viewBox: "0 0 312 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2105 82.4233C25.2127 82.8369 371.297 87.9146 301.043 29.9959C230.789 -27.9228 12.8984 12.4781 2.01339 52.7624C-6.6946 84.9898 99.2108 89.3747 153.252 87.5387",
    stroke: "#F37E21",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordRoundedShape);
export default __webpack_public_path__ + "static/media/word-rounded-shape.74d5b5de77e9da935c8ffb7bcb9782c7.svg";
export { ForwardRef as ReactComponent };